import forOwn from 'lodash/forOwn';
import isUndefined from 'lodash/isUndefined';
import isNull from 'lodash/isNull';
import isNaN from 'lodash/isNaN';
import isString from 'lodash/isString';
import isEmpty from 'lodash/isEmpty';
import isObject from 'lodash/isObject';
import isArray from 'lodash/isArray';
import pull from 'lodash/pull';
import cloneDeep from 'lodash/cloneDeep';

export function hasClass(el, className) {
     if (el.classList) {
          return el.classList.contains(className);
     }
     return !!el.className.match(new RegExp('(\\s|^)' + className + '(\\s|$)'));
}

export function addClass(el, className) {
     if (el.classList) {
          el.classList.add(className);
     } else if (!hasClass(el, className)) {
          el.className += ' ' + className;
     }
}

export function removeClass(el, className) {
     if (el.classList) {
          el.classList.remove(className);
     } else if (hasClass(el, className)) {
          const reg = new RegExp('(\\s|^)' + className + '(\\s|$)');
          el.className = el.className.replace(reg, ' ');
     }
}

export function pruneEmpty(obj) {
     return (function prune(current) {
          forOwn(current, (value, key) => {
               if (
                    isUndefined(value) ||
                    isNull(value) ||
                    isNaN(value) ||
                    (isString(value) && isEmpty(value)) ||
                    (isObject(value) && isEmpty(prune(value)))
               ) {
                    delete current[key];
               }
          });
          // remove any leftover undefined values from the delete
          // operation on an array
          if (isArray(current)) {
               pull(current, undefined);
          }

          return current;
     })(cloneDeep(obj)); // Do not modify the original object, create a clone instead
}
